import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import img14 from "../../assets/img/img14.jpg";
import Avatar from "../../components/Avatar";

const PORTFOLIO_TABS = [
  { key: "introduce", label: "미러포트폴리오" },
  { key: "top10", label: "Top10종목" },
  { key: "newbuy", label: "신규매수종목" },
  { key: "addbuy", label: "추가매수종목" },
  { key: "sell", label: "매도종목" },
];

const ALGO_AVATAR_BG_CLASSES = ["primary", "secondary", "success", "info", "danger", "dark"];

// algo 카테고리는 이미지 대신 이니셜 아바타 배경색을 seed 기반으로 고정한다.
function getAlgoAvatarBg(seedValue) {
  const seed = String(seedValue || "");
  if (!seed) return ALGO_AVATAR_BG_CLASSES[0];
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
  }
  return ALGO_AVATAR_BG_CLASSES[hash % ALGO_AVATAR_BG_CLASSES.length];
}

function HeaderImageAvatar({ item, initialChar }) {
  const defaultSrc = item?.guruid ? `/images/webp/${item.guruid}.webp` : img14;
  const [imgSrc, setImgSrc] = useState(defaultSrc);

  useEffect(() => {
    setImgSrc(defaultSrc);
  }, [defaultSrc]);

  // 실이미지 -> 기본 이미지 -> 이니셜 순으로 fallback한다.
  if (imgSrc) {
    return (
      <div className="avatar">
        <img
          src={imgSrc}
          alt=""
          onError={() => {
            if (imgSrc !== img14) {
              setImgSrc(img14);
              return;
            }
            setImgSrc(null);
          }}
        />
      </div>
    );
  }

  return (
    <div className="avatar">
      <span className="avatar-initial">{initialChar}</span>
    </div>
  );
}

function HeaderAvatar({ item, isAlgoCategory = false }) {
  const initialChar = (item?.leader || item?.nickname || item?.guruid || "?").charAt(0);
  // algo는 이미지 대신 Avatar 컴포넌트로 이니셜을 강제 렌더링한다.
  if (isAlgoCategory) {
    const algoBg = getAlgoAvatarBg(`${item?.guruid || ""}-${item?.leader || item?.nickname || ""}`);
    return (
      <Avatar
        initial={initialChar}
        bg={algoBg}
        shape="rounded"
      />
    );
  }

  return <HeaderImageAvatar item={item} initialChar={initialChar} />;
}

export default function PortfolioBodyHeader({
  dashboard,
  category = "",
  tabActive = "introduce",
  onSelectTab,
  onBack,
}) {
  const item = dashboard;
  const normalizedCategory = typeof category === "string" ? category.toUpperCase() : "";
  const isAlgoCategory = normalizedCategory === "ALGO";
  const navRef = useRef(null);
  const tabRefs = useRef({});

  // 스와이프나 클릭으로 활성 탭이 바뀌면 탭 스트립에서 해당 항목이 항상 보이도록 스크롤을 보정한다.
  useEffect(() => {
    const navElement = navRef.current;
    const activeElement = tabRefs.current[tabActive];
    if (!navElement || !activeElement) return;

    const navRect = navElement.getBoundingClientRect();
    const activeRect = activeElement.getBoundingClientRect();
    const isOutOfView = activeRect.left < navRect.left || activeRect.right > navRect.right;
    if (!isOutOfView) return;

    activeElement.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [tabActive]);

  return (
    <>
      <div className="chat-body-header">
        <div className="chat-item">
          <HeaderAvatar item={item} isAlgoCategory={isAlgoCategory} />
          <div className="chat-item-body">
            <span className="chat-item-title mb-1">{item?.leader}</span>
            <span>{item?.institution || "No institution"}</span>
          </div>
        </div>
        <Link
          to=""
          className="header-link ms-auto d-lg-none"
          onClick={(e) => {
            // 모바일에서는 헤더 뒤로가기 버튼으로 목록 패널을 다시 연다.
            e.preventDefault();
            if (onBack) {
              onBack();
            }
          }}
          title="목록으로"
        >
          <i className="ri-arrow-left-s-line"></i>
        </Link>
      </div>
      <div>
        <Nav ref={navRef} className="nav-line px-3 flex-nowrap overflow-x-auto overflow-y-hidden nav-scroll-hide">
          {/* 탭 선택은 상위에서 tabActive 상태를 관리한다. */}
          {PORTFOLIO_TABS.map((tab) => (
            <Nav.Link
              key={tab.key}
              ref={(element) => {
                tabRefs.current[tab.key] = element;
              }}
              href=""
              active={tabActive === tab.key}
              className={`${tabActive === tab.key ? "active fw-bold" : ""} fw-normal`}
              onClick={(e) => {
                e.preventDefault();
                if (onSelectTab) {
                  onSelectTab(tab.key);
                }
              }}
            >
              {tab.label}
            </Nav.Link>
          ))}
        </Nav>
      </div>
    </>
  );
}
